import { NgModule } from '@angular/core';
import { AxisCaptchaComponent } from './captcha.component';
import { AXIS_CAPTCHA_SERVICE_PROVIDER } from './captcha.service';

@NgModule({
    declarations: [AxisCaptchaComponent],
    exports: [AxisCaptchaComponent],
    providers: [AXIS_CAPTCHA_SERVICE_PROVIDER]
})
export class AxisCaptchaModule {}
